export class TagService {
    constructor(params) {
        if(params.apiUrl === null || params.apiUrl === undefined) {
            throw new TypeError('property apiUrl not found');
        }

        this.apiUrl = params.apiUrl;
    }

    getUserTags(userId) {
        return fetch(`${this.apiUrl}/tags?userId=${userId}`).then(response => {
            if (response.status !== 200) throw Error("Error");
            
            return response.json();
        }).catch(error => {
            console.error(error);
        });
    }

    getSystemTags() {
        return fetch(`${this.apiUrl}/tags`).then(response => {
            if (response.status !== 200) throw Error("Error");
            
            return response.json();
        }).catch(error => {
            console.error(error);
        });
    }  
}


// WEBPACK FOOTER //
// src/services/tag.service.js